import { useSelector } from "react-redux";
import { hasPermission } from "go-security/services/organizations/selectors";

export const stockStatePermission = "STOCK_STATES_PREVIEW";

export const documentPermission = [
	"PURCHASE_ORDER_",
	"SALES_ORDER_",
	"TRANSFER_ORDER_",
	"STOCK_ADJUSTMENT_",
	"BUNDLE_",
	"INVOICE_",
];

export const stockTakingPermission = "STOCKTAKING_";

export const productPermission = "PRODUCT_";

export const contactPermission = "CONTACT_";

export const reportPermission = "REPORT";
export const settingsPermission = "SETTINGS";
export const segmentPermission = "SEGMENT";
export const managePermission = "MANAGE";

export const useHasPermission = () => {
	const hasStockStatePermission = useSelector(hasPermission(stockStatePermission));
	const hasDocumentPermission = useSelector(hasPermission(documentPermission, true));
	const hasStockTakingPermission = useSelector(hasPermission(stockTakingPermission, true));
	const hasProductPermission = useSelector(hasPermission(productPermission, true));
	const hasContactPermission = useSelector(hasPermission(contactPermission, true));
	const hasReportPermission = useSelector(hasPermission(reportPermission));
	const hasSettingsPermission = useSelector(hasPermission(settingsPermission));
	const hasSegmentPermission = useSelector(hasPermission(segmentPermission));
	const hasManagePermission = useSelector(hasPermission(managePermission));
	const hasSupportPermission = useSelector(hasPermission("SUPPORT"));

	return {
		hasStockStatePermission,
		hasDocumentPermission,
		hasStockTakingPermission,
		hasProductPermission,
		hasContactPermission,
		hasReportPermission,
		hasSettingsPermission,
		hasSegmentPermission,
		hasManagePermission,
		hasSupportPermission,
	};
};
